import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { ToolSpecV2 } from "components/ToolParamsGrid/ToolParamsGrid.types";
import { queryKeys } from "django/queryKeys";
import { Tool } from "graphql/_Types";
import { getEnvVar } from "ideas.env";
import { ToolStatus, ToolVisibility } from "types/constants";
import { ToolSpecV3 } from "types/json-schemas/ToolSpecV3";
import { getRequestHeaders } from "utils/getRequestHeaders";

export type ToolDetails = {
  id: Tool["id"];
  name: string;
  key: string;
  date_created: string;
  help_text: string | null;
  docs_link: string | null;
  code_link: string | null;
  project: {
    id: string;
    key: string;
    test_table: string;
  };
  versions: {
    id: number;
    version: string;
    date_created: string;
    tool_spec: ToolSpecV2 | ToolSpecV3 | null;
    status: ToolStatus;
    visibility: ToolVisibility;
    is_draft_spec_synced: boolean;
    changelog: string;
    container_image: number;
  }[];
  latest_tool_version: (Pick<Tool, "id"> & { status: ToolStatus }) | null;
};

export const useGetToolQuery = (toolId: number) => {
  return useQuery<ToolDetails, Error>({
    queryKey: queryKeys.tool(toolId),
    queryFn: async () => {
      const url = getEnvVar("URL_TRS_TOOL_DETAILS")(toolId);
      const headers = await getRequestHeaders();
      const res = await axios.get<ToolDetails>(url, { headers });
      return res.data;
    },
  });
};
